import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { TableWrapper, Inner, Header, Body, Row, Head, Ceil } from './styles';

class Table extends PureComponent {
  renderHeading = heading => {
    const headingProps = heading.props || {};

    if (typeof heading.render === 'function') {
      return heading.render({
        key: heading.id,
        children: heading.children,
        ...headingProps,
      });
    }

    return (
      <Head key={heading.id} {...headingProps}>
        {heading.children}
      </Head>
    );
  };

  renderRow = row => <Row key={row.id}>{row.ceils.map(this.renderCeil)}</Row>;

  renderCeil = ceil => {
    if (typeof ceil.render === 'function') {
      return ceil.render();
    }

    return (
      <Ceil {...(ceil.props || {})} key={ceil.key}>
        {ceil.children}
      </Ceil>
    );
  };

  render() {
    const { columns, rows, ...props } = this.props;

    return (
      <TableWrapper>
        <Inner {...props}>
          <Header>
            <Row>{columns.map(this.renderHeading)}</Row>
          </Header>

          <Body>{rows.map(this.renderRow)}</Body>
        </Inner>
      </TableWrapper>
    );
  }
}

Table.propTypes = {
  title: PropTypes.node,
  columns: PropTypes.arrayOf(PropTypes.object),
  rows: PropTypes.arrayOf(PropTypes.object),
};

Table.defaultProps = {
  title: null,
  columns: [],
  rows: [],
};

export default Table;
